import { AxiosResponse } from 'axios'
import {
  IEntityGST,
  IGenericResponseGST,
  IPaginatedEntityGST
} from 'services/core/genericEntityGST'
import { RequestREAD, RequestGST, RequestCDU } from 'services/Instances'
import { TipoPendencia } from 'utils/types'

const RegisterPendingServices = () => {
  const path = 'TipoPendencia'
  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const del = async (id: number): Promise<AxiosResponse> =>
    await RequestCDU.delete(`${path}/Delete?id=${id}`)

  const getAll = async (params?: TipoPendencia): Promise<AxiosResponse<TipoPendencia[]>> =>
    await RequestREAD.get(path, {
      params: params
      
    })

  const get = async (id: number): Promise<AxiosResponse<TipoPendencia>> =>
    await RequestREAD.get(`${path}/${id}`)

  const patch = async (requestObj: TipoPendencia): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  return { create, del, get, getAll, patch }
}

export { RegisterPendingServices }

export const CadastroSegurancaItensSubItensServices = () => {
  const mockend_endpoints = {
    getAllItems: 'items_subtiems_seguranca_getallitems',
    getAllSubItems: 'items_subtiems_seguranca_getallsubitens'
  }

  const getAllItems = async (): Promise<
    AxiosResponse<IGetAllItensSegurancaResponse[]>
  > => await RequestGST.get('SubitemSeguranca')

  const getAllSubItems = async (): Promise<
    AxiosResponse<IGetAllSubItensResponse[]>
  > => await RequestREAD.get(mockend_endpoints['getAllSubItems'])

  const deleteSubItem = async (
    idSubItem: number
  ): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.delete('SubitemSeguranca', {
      params: {
        idEntity: idSubItem
      }
    })

  const deleteItemSeguranca = async (
    idItemSeguranca: number
  ): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.delete('ItensSeguranca', {
      params: { idEntity: idItemSeguranca }
    })

  const updateItemSeguranca = async (
    body: IUpdateItemSegurancaBody
  ): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.put('ItensSeguranca', body)

  const updateSubItemSeguranca = async (
    body: IUpdateSubItemSeguranca
  ): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.put('SubitemSeguranca', body)

  const createItemSeguranca = async (
    body: ICreateItemSegurancaBody
  ): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.post('ItensSeguranca', body)

  const createSubItemSeguranca = async (
    body: ICreateSubItemSegurancaBody
  ): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.post('SubitemSeguranca', body)

  const getItemSegurancaByName = async (
    nmItemSeguranca: string
  ): Promise<AxiosResponse<IEntityGST<IGetAllItemsResponse>>> =>
    await RequestGST.get('ItensSeguranca/GetItemSegurancaByNome', {
      params: { nmItemSeguranca }
    })

  const getSubItemSegurancaByName = async (
    nmsubItemSeguranca: string
  ): Promise<AxiosResponse<IEntityGST<IGetAllItemsResponse>>> =>
    await RequestGST.get('SubitemSeguranca/GetSubItemByName', {
      params: { nmsubItemSeguranca }
    })

  const createItemSegurancaWithSubItem = async (
    body: ICreateItemSegurancaWithSubItemBody
  ): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.post('ItensSeguranca/CadastrarItensSeguranca', body)

  return {
    createItemSeguranca,
    createSubItemSeguranca,
    deleteItemSeguranca,
    deleteSubItem,
    getAllItems,
    getAllSubItems,
    getItemSegurancaByName,
    getSubItemSegurancaByName,
    updateItemSeguranca,
    updateSubItemSeguranca,
    createItemSegurancaWithSubItem
  }
}

export interface ICreateSubItemSegurancaBody {
  idSubItemSeguranca?: number
  itemSegurancaId?: number
  idInfracaoSubItemSeguranca: number
  nmSubItemSeguranca: string
  txSubItemDescricao: string
}

export interface ICreateItemSegurancaBody {
  idItemSeguranca: number
  nmItemSeguranca: string
  txDescricaoItemSeguranca: string
  txLegislacaoItemSeguranca: string
}

export interface ICreateItemSegurancaWithSubItemBody {
  idItemSeguranca: number
  nmItemSeguranca: string
  txDescricaoItemSeguranca: string
  txLegislacaoItemSeguranca: string
  listaItensSeguranca: ICreateSubItemBody[]
}

export interface ICreateSubItemBody {
  idSubItemSeguranca?: number,
  itemSegurancaId?: number,
  idInfracaoSubItemSeguranca: number,
  nmSubItemSeguranca: string,
  txSubItemDescricao: string
}


export interface IUpdateSubItemSeguranca {
  idSubItemSeguranca: number
  itemSegurancaId: number
  idInfracaoSubItemSeguranca: number
  nmSubItemSeguranca: string
  txSubItemDescricao: string
}

export interface IUpdateItemSegurancaBody {
  idItemSeguranca: number
  nmItemSeguranca: string
  txDescricaoItemSeguranca: string
  // flTipoItemSeguranca: string
  txLegislacaoItemSeguranca: string
}

export interface IGetAllItemsResponse {
  dsItemSeguranca: string
  flTipoItemSeguranca: string
  idItemSeguranca: number
  nmItemSeguranca: string
  txLegislacaoItemSeguranca: string
  //local states
  isSubItem?: boolean
}

export interface IGetAllItensSegurancaResponse {
  dsItemSeguranca: string
  flTipoItemSeguranca: string
  idItemSeguranca: number
  nmItemSeguranca: string
  txLegislacaoItemSeguranca: string
}

export interface IGetAllSubItensParams {
  idItemSeguranca: number

  pageNumber?: number
  pageSize?: number
}

export interface IGetAllSubItensResponse {
  idSubItemSeguranca: number
  idItemSeguranca: number
  idInfracao: number
  nmSubItem: string
  dsSubItem: string
  nuNivelInfracao: string
  idVisualizacaoSubItem: string
  flSubItem: boolean
  //local states
  isSubItem?: boolean
}
